<template>
    <div class="google-consent-error-page">
        <div class="google-consent-error-page__header">
            <div class="google-consent-error-page__header-logo">
                <CompassLogo type="logo" :width="160" />
            </div>
        </div>

        <div class="google-consent-error-page__content">
            <div class="google-consent-error-page__content-illustration">
                <img src="/ressources/logged/img/illustrations/google-granular-consent.svg" />
            </div>

            <p class="google-consent-error-page__content-title typographies-display-large">
                {{ $t.__('consent.GoogleGranularConsentErrorPage.title') }}
            </p>

            <p
                class="google-consent-error-page__content-information typographies-paragraph-x-large-regular"
            >
                {{ $t.__('consent.GoogleGranularConsentErrorPage.information') }}
            </p>

            <div class="google-consent-error-page__content-buttons">
                <CompassButton
                    :label="$t.__('consent.GoogleGranularConsentErrorPage.button.label')"
                    size="large"
                    @click="goToUrl(connectionUrl)"
                />
            </div>

            <p
                class="google-consent-error-page__content-help typographies-paragraph-medium-semibold"
            >
                {{ $t.__('common.labels.need_help') }}
                <CompassLink
                    :label="$t.__('common.labels.chat_with_our_advisors')"
                    link="javascript:;"
                    @click="openIntercom"
                />
            </p>
        </div>
    </div>
</template>

<script>
import { goToUrl } from 'vueDir/helpers.js';

export default {
    props: {
        connectionUrl: {
            type: String,
            required: true,
        },
    },
    methods: {
        goToUrl,
        openIntercom() {
            window.Intercom('show');
        },
    },
};
</script>

<style lang="scss" scoped>
.google-consent-error-page {
    display: flex;
    flex-direction: column;
    align-items: center;
    height: 100%;

    &__header {
        align-self: flex-start;
    }

    &__content {
        margin: auto;

        &-illustration {
            text-align: center;
            margin-bottom: var(--spacing-5);

            > img {
                height: 200px;
                width: auto;
            }
        }

        &-title {
            text-align: center;
            color: var(--colors-common-text-brand-secondary-blue, #02016f);
            margin: 0 0 var(--spacing-3);
        }

        &-information {
            text-align: center;
            color: var(--colors-common-text-subtle-default, #565665);
            margin: 0 0 var(--spacing-5);
        }

        &-buttons {
            display: flex;
            justify-content: center;
            margin-bottom: var(--spacing-4);
        }

        &-help {
            text-align: center;
            margin: 0;
            color: var(--colors-common-text-standard-caption, #8c909c);
        }
    }
}
</style>
